<template>
  <div class="practice container">
    <div class="box">
      <el-page-header @back="$router.go(-1)" content="实战库"> </el-page-header>
      <el-form :model="params" class="search_form" :inline="true" size="small">
        <el-form-item prop="title">
          <el-input v-model="params.title" placeholder="搜索"
            ><el-button
              slot="append"
              size="small"
              icon="el-icon-search"
              @click="getList"
            ></el-button
          ></el-input>
        </el-form-item>
        <el-form-item prop="taskType">
          <el-radio-group v-model="params.taskType" @change="getList">
            <el-radio-button :label="null">全部</el-radio-button>
            <el-radio-button label="PERSONAL">个人</el-radio-button>
            <el-radio-button label="TEAM">团队</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <el-button
            class="add-btn"
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="
              $router.push({
                path: '/courseDetail/practice/detail',
                query: { ...$route.query, isBank: 1 },
              })
            "
            >新增实战</el-button
          >
        </el-form-item>
      </el-form>
      <el-table
        class="practice_list"
        :data="list"
        height="calc(100% - 50px - 32px - 20px - 44px)"
      >
        <el-table-column prop="title" label="文件名称"> </el-table-column>
        <el-table-column
          prop="taskType"
          width="100"
          label="类型"
          :formatter="formatter"
        >
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleRelease(scope.row.taskStoreId)"
            >
              发布
            </el-button>
            <el-button
              type="text"
              size="small"
              @click="handleDetail(scope.row.taskStoreId)"
            >
              {{ scope.row.taskStoreId == 0 ? "查看" : "编辑" }}
            </el-button>
            <el-button
              v-show="scope.row.taskStoreId != 0"
              @click="handleDel(scope.row.taskStoreId)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  practiceBankList,
  bankDelPractice,
  bankReleasePractice,
} from "@/api/practice";
export default {
  props: {
    info: Object,
  },
  data() {
    return {
      params: {
        title: "",
        classId: this.$route.query.id,
        chapterId: this.$route.query.chapterId,
        taskType: null,
      },
      list: [],
    };
  },
  activated() {
    this.getList();
  },
  methods: {
    //   列表
    getList() {
      this.params.chapterId = this.$route.query.chapterId;
      this.$loading.show();
      practiceBankList(this.params).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.list = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    formatter(row) {
      if (row.taskType == "PERSONAL") {
        return "个人";
      } else if (row.taskType == "TEAM") {
        return "团队";
      }
    },
    // 发布
    handleRelease(taskStoreId) {
      let classId = this.$route.query.id;
      let chapterId = this.$route.query.chapterId;
      this.$confirm("确定要发布该实战吗?", {
        type: "warning",
      })
        .then(() => {
          bankReleasePractice({ taskStoreId, classId, chapterId }).then(
            (res) => {
              this.$loading.hide();
              if (res.code == 0) {
                this.$message.success("发布成功");
                this.$router.go(-1);
              } else {
                this.$message.error(res.msg);
              }
            }
          );
        })
        .catch(() => {});
    },
    // 详情
    handleDetail(taskId) {
      if (taskId == 0)
        this.$router.push({
          path: "/courseDetail/practice/pdf",
          query: { ...this.$route.query },
        });
      else
        this.$router.push({
          path: "/courseDetail/practice/detail",
          query: { ...this.$route.query, taskId, isBank: 1 },
        });
    },
    // 删除
    handleDel(taskStoreId) {
      this.$confirm("确定要删除该实战吗?", {
        type: "warning",
      })
        .then(() => {
          bankDelPractice(taskStoreId).then((res) => {
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.practice {
  height: 100%;
  text-align: left;
  .box {
    padding: 25px 35px;
    margin: 30px auto;
    height: calc(100% - 60px);
    background-color: #fff;
    ::v-deep .el-page-header {
      margin-bottom: 20px;
      .el-page-header__content {
        font-size: 16px;
      }
    }
    ::v-deep .search_form {
      .el-form-item {
        margin-right: 50px;
        .el-input-group__append {
          background-color: teal;
          border-color: teal;
          color: #fff;
        }
      }
    }
    ::v-deep .practice_list {
      margin-top: 5px;
      .is-leaf {
        color: #333;
        background-color: #f5f5f5;
      }
    }
  }
}
</style>